const transforms = new Map<string, (items: unknown[]) => unknown[]>();

export function registerItemsTransform(
  id: string,
  transform: (items: unknown[]) => unknown[],
): void {
  transforms.set(id, transform);
}

export function applyItemsTransform(
  id: string | null | undefined,
  items: unknown[],
): unknown[] {
  if (!id) return items;
  const fn = transforms.get(id);
  return fn ? fn(items) : items;
}
